import type { SupabaseClient } from "@supabase/supabase-js";

type FileRef = string;

export type FileState = {
  file: File;
  bucket: string;
  path: string | null;
  url: string | null;
  progress: number;
  error?: Error;
};

let globalStore: Ref<Record<FileRef, FileState>>;
export const useImageUploadStore = (): Ref<Record<FileRef, FileState>> => {
  if (!globalStore) globalStore = ref({});

  return globalStore;
};

export const useImageUploader = () => {
  const client = useNuxtApp().$supabase?.client as SupabaseClient;
  const images = useImageUploadStore();

  return function upload(file: File): FileRef {
    const fileRef = randomString() as FileRef;

    const image: FileState = (images.value[fileRef] = {
      file,
      bucket: "media",
      path: file.name,
      progress: 0,
      url: null,
      error: undefined,
    });

    client.storage
      .from("media")
      .upload(`${new Date().toISOString()}/${file.name}`, file)
      .then(async (res) => {
        if (res.error) {
          images.value[fileRef].error = res.error;
          return;
        }

        const path = res.data?.path;
        if (!path) {
          throw new Error("No path");
        }

        images.value[fileRef].path = path;
        const {
          data: { publicUrl },
        } = await client.storage.from("media").getPublicUrl(path);
        if (!publicUrl) throw new Error("No public URL");
        images.value[fileRef].url = publicUrl;
      })
      .catch((x) => console.error(x));

    return fileRef;
  };
};
